<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">
    
            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Boletín Concursal</h1>
                <button mat-flat-button 
                    class="custom-button-primary no-print"
                    (click)="descargarPDF()"
                >
                    <mat-icon 
                        aria-hidden="false" 
                        aria-label="Icono de descarga" 
                        fontIcon="get_app" 
                        class="icon-download mr-3"
                    ></mat-icon>
                    Descargar Resultado
                </button>
            </div>
    
            <!--<div class="col-12" *ngIf="!showHeader">
                <h1>Boletín Concursal</h1>
            </div>-->
    
            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut"><strong>RUT:</strong> {{content.boletinConcursalReporte.principal.encabezado.rut | number :
                        '1.0-0'}}-{{content.boletinConcursalReporte.principal.encabezado.dv | uppercase}}</mat-chip>
                </mat-chip-set>
            </div>
    
            <div class="col-12">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Datos del procedimiento</strong>
                        </mat-card-title>
                    </mat-card-header>
                
                    <mat-card-content>
        
                        <div class="row p-5">
                            <div class="col-12 border mx-auto">
                                <table mat-table [dataSource]="datosProcedimiento" class="info-basica-table">
                                    <ng-container matColumnDef="name">
                                        <th mat-cell *matCellDef="let element" class="cell-font-size">{{element.name}}</th>
                                    </ng-container>
                                
                                    <ng-container matColumnDef="value">
                                        <td mat-cell *matCellDef="let element" class="cell-font-size">
                                            <ng-container [ngSwitch]="element.name">
                                                <ng-container *ngSwitchCase="'Rut Deudor'">
                                                    {{element.value ? (element.value | rutFormat) : ''}}
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    {{element.value}}
                                                </ng-container>
                                            </ng-container>
                                        </td>
                                    </ng-container>
                                
                                    <tr
                                        mat-row
                                        *matRowDef="let row; columns: displayedColumns;"
                                    ></tr>
                                </table>
                            </div>
                            <div class="col-12 mt-5 px-0 not-print">
                                <button mat-stroked-button class="custom-button-outline" (click)="setDetalles()">{{verDetalle ? 'Ocultar' : 'Ver'}} detalle</button>
                            </div>
                        </div>
        
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-12 mt-4 div-print-only" [ngClass]="{'d-none': !verDetalle}">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Publicaciones asociadas al procedimiento</strong>
                        </mat-card-title>
                    </mat-card-header>
                
                    <mat-card-content>
        
                        <div class="row p-5"><!-- *ngIf="listaDetalles && listaDetalles.length > 0; else noData"-->
                            <div class="col-12 border mx-auto px-0 not-print">
              
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="dataSource" matSort>
                                        <ng-container matColumnDef="nombrePublicacion">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por Nombre Publicacion"> Nombre Publicación </th>
                                            <td mat-cell *matCellDef="let element"> {{element.nombrePublicacion}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="fchPublicacion">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por Fecha Publicacion"> Fecha Publicación </th>
                                            <td mat-cell *matCellDef="let element"> {{element.fchPublicacion}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="entePublicador">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por Vendedor / Liquidador / Martillero"> Vendedor / Liquidador / Martillero </th>
                                            <td mat-cell *matCellDef="let element"> {{element.entePublicador}} </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="header"></tr>
                                        <tr mat-row *matRowDef="let row; columns: header;"></tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-12 border mx-auto px-0 div-print">
              
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="listaDetalles ? listaDetalles : []">
                                        <ng-container matColumnDef="nombrePublicacion">
                                            <th mat-header-cell *matHeaderCellDef> Nombre Publicación </th>
                                            <td mat-cell *matCellDef="let element"> {{element.nombrePublicacion}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="fchPublicacion">
                                            <th mat-header-cell *matHeaderCellDef> Fecha Publicación </th>
                                            <td mat-cell *matCellDef="let element"> {{element.fchPublicacion}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="entePublicador">
                                            <th mat-header-cell *matHeaderCellDef> Vendedor / Liquidador / Martillero </th>
                                            <td mat-cell *matCellDef="let element"> {{element.entePublicador}} </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="header"></tr>
                                        <tr mat-row *matRowDef="let row; columns: header;"></tr>
                                    </table>
                                </div>
                            </div>
                            <div class="col-12 mt-3 not-print">
                                <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons aria-label="Seleccionar página">
                                </mat-paginator>
                            </div>
                        </div>
        
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-12 my-4">
                <div class="info-span p-3">
                    <p class="text-center text-wrap">
                        La información presentada en estos análisis proviene de fuentes consideradas altamente confiables. Sin embargo, dada la posibilidad de error humano o mecánico, no
                        se garantiza la exactitud o integridad de la información y, por tanto, no se hace responsable de errores u omisiones, como tampoco de las consecuencias asociadas con
                        el empleo de esa información.
                    </p>
                </div>
            </div>
    
        </div>
    </mat-card-content>
</mat-card>
